import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=127a7085&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"
import style0 from "./Authenticate.vue?vue&type=style&index=0&id=127a7085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a7085",
  null
  
)

/* custom blocks */
import block0 from "./Authenticate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports